import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSupport = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3 8.89062H5.33333C5.74589 8.89062 6.14155 9.05195 6.43328 9.33912C6.725 9.62628 6.88889 10.0158 6.88889 10.4219V12.7188C6.88889 13.1249 6.725 13.5143 6.43328 13.8015C6.14155 14.0887 5.74589 14.25 5.33333 14.25H4.55556C4.143 14.25 3.74733 14.0887 3.45561 13.8015C3.16389 13.5143 3 13.1249 3 12.7188V8.89062ZM3 8.89062C3 7.98574 3.18106 7.08971 3.53284 6.2537C3.88463 5.41769 4.40024 4.65807 5.05025 4.01822C5.70026 3.37836 6.47194 2.8708 7.32122 2.52452C8.1705 2.17823 9.08075 2 10 2C10.9193 2 11.8295 2.17823 12.6788 2.52452C13.5281 2.8708 14.2997 3.37836 14.9497 4.01822C15.5998 4.65807 16.1154 5.41769 16.4672 6.2537C16.8189 7.08971 17 7.98574 17 8.89062M17 8.89062V12.7188C17 13.1249 16.8361 13.5143 16.5444 13.8015C16.2527 14.0887 15.857 14.25 15.4444 14.25H14.6667C14.2541 14.25 13.8584 14.0887 13.5667 13.8015C13.275 13.5143 13.1111 13.1249 13.1111 12.7188V10.4219C13.1111 10.0158 13.275 9.62628 13.5667 9.33912C13.8584 9.05195 14.2541 8.89062 14.6667 8.89062H17ZM17 13.375V14.8333C17 15.6069 16.6722 16.3487 16.0888 16.8957C15.5053 17.4427 14.714 17.75 13.8889 17.75H10",
		stroke: "",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgSupport;
